import React,{Component} from 'react';
import Button from '@react/react-spectrum/Button';
import ModalTrigger from '@react/react-spectrum/ModalTrigger';
import {withTranslation } from 'react-i18next';
import CustomPDFDialog from './CustomPDFDialog';
import {connect} from "react-redux";

export class PDFModal extends Component{

    handlePDFDownload = (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        // Call the onPDFDownload callback if provided
        if (this.props.onPDFDownload) {
            this.props.onPDFDownload();
        }
    };

    render(){
        return(
            <ModalTrigger>
                <Button 
                    label={this.props.btnLabel || "View PDF"} 
                    variant={this.props.variant || "secondary"}
                    modalTrigger 
                    data-am-id="viewPdfModalBtn"
                    data-agreement-id={this.props.agreementId}
                />
                <CustomPDFDialog 
                    pdfUrl={this.props.pdfUrl}
                    agreementNumber={this.props.agreementNumber}
                    customerName={this.props.customerName}
                    locale={this.props.locale}
                    userDetails={this.props.userDetails}
                    agreementId={this.props.agreementId}
                    onPDFDownload={this.handlePDFDownload}
                    status={this.props.status}
                    backdropClickable
                />
            </ModalTrigger>
        )
    }
}

const mapStateToProps = (state)=>{
    return{
        locale:state.LocaleReducer.value,
        userDetails:state.AuthReducer.userInfo
    }
};

export default connect(mapStateToProps)(withTranslation()(PDFModal));
